import React from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";

import Home from "./Page/Home";
import Blog from "./Page/Blog";
import Book from "./Book/Book";
import Landing from "./Landing/Landing";
import Profile from "./Profile/Profile";
import EditProfile from "./Profile/EditProfile";
import Forum from "./Forum/Forum";
import Club from "./Page/Bashgah";
import Exam from "./Exam/Exam";
import BookRead from "./Book/BookRead";
import Introduce from "./Blog/Introduc";
import BlogAlerts from "./Blog/BlogAlerts";
import News from "./Blog/News";
import KetaBlogItem from "./Blog/KetaBlogItem";
import KetaBlog from "./Blog/KetaBlog";
import TermsAndConditions from "./Blog/TermsAndConditions";
import TermsOfUse from "./Blog/TermsOfUse";
import Guide from "./Blog/Guide";
import BlogFAQ from "./Blog/BlogFAQ";
import BookInfo from "./Blog/BookInfo";
import Support from "./Profile/Support";
import InviteFriends from "./Profile/InviteFriends";
import Cart from "./Cart/Cart";
import BookAction from "./Blog/BookAction";
import Chat from "./Profile/Chat";
import SekeBashgah from "./Club/SekeBashgah";
import FreeDiscussion from "./Blog/FreeDiscussion";
import EmtiyazBashgah from "./Club/EmtiyazBashgah";
import NeshanBashgah from "./Club/NeshanBashgah";
import MedalBashgah from "./Club/MedalBashgah";
import Activities from "./Profile/Activities";
import Saved from "./Profile/Saved";
import OfferCodes from "./Profile/OfferCodes";
import UserBookAction from "./Blog/UserBookAction";
import PrintedVersion from "./Profile/printedVersion";
import Ambassadors from "./ambassadors/Ambassadors";
import LoginAmbassadors from "./ambassadors/Login-ambassadors";
import AccountAmbassadors from "./ambassadors/account-ambassadors";
import HisstoriPlus from "./hisstoriPlus";
import Knowledge from "./hisstoriPlus/Knowledge";
import TvPlus from "./hisstoriPlus/tv-plus";
import TvExamination from "./hisstoriPlus/tv-examination";
import KnowledgeExamination from "./hisstoriPlus/knowledge-examination";

const Authenticated = (props) => {
  return (
    <>
      <ToastContainer />
      <Routes>
        {/* =================================== Without Permission =================================== */}

        <Route exact path="/hisstori" element={<Landing />} />
        <Route exact path="/hisstori/home" element={<Home />} />
        <Route exact path="/hisstori/blog" element={<Blog />} />
        <Route exact path="/hisstori/club" element={<Club />} />
        <Route exact path="/book/SE:id/:name" element={<Book />} />
        <Route exact path="/profile" element={<Profile />} />
        <Route exact path="/edit-profile" element={<EditProfile />} />
        <Route exact path="/forum" element={<Forum />} />
        <Route exact path="/exam/:id" element={<Exam />} />
        <Route exact path="/hisstori/blog/introduce" element={<Introduce />} />
        <Route exact path="/hisstori/blog/alerts" element={<BlogAlerts />} />
        <Route exact path="/hisstori/blog/news" element={<News />} />
        <Route exact path="/hisstori/blog/:id" element={<BookInfo />} />
        <Route exact path="/support" element={<Support />} />
        <Route exact path="/cart" element={<Cart />} />
        <Route exact path="/chat" element={<Chat />} />
        <Route exact path="/activities" element={<Activities />} />
        <Route exact path="/saved" element={<Saved />} />
        <Route exact path="/offer-codes" element={<OfferCodes />} />
        <Route
          exact
          path="/hisstori/club/free-discussion"
          element={<FreeDiscussion />}
        />
        <Route
          exact
          path="/hisstori/blog/:id/action"
          element={<BookAction />}
        />
        <Route
          exact
          path="/hisstori/blog/:userId/user/:id/action/:actionId"
          element={<UserBookAction />}
        />
        <Route
          exact
          path="/hisstori/club/invite-friend"
          element={<InviteFriends />}
        />
        <Route
          exact
          path="/hisstori/blog/keta-blog-introduce/:id"
          element={<KetaBlogItem />}
        />
        <Route
          exact
          path="/hisstori/blog/keta-blog/:id"
          element={<KetaBlog />}
        />
        <Route exact path="/hisstori/blog/keta-blog" element={<KetaBlog />} />
        <Route
          exact
          path="/hisstori/blog/term-and-conditions"
          element={<TermsAndConditions />}
        />
        <Route
          exact
          path="/hisstori/blog/term-of-use"
          element={<TermsOfUse />}
        />
        <Route exact path="/hisstori/blog/guide" element={<Guide />} />
        <Route exact path="/hisstori/blog/faq" element={<BlogFAQ />} />

        <Route exact path="/hisstori/club/my-coins" element={<SekeBashgah />} />
        <Route
          exact
          path="/hisstori/club/my-scores"
          element={<EmtiyazBashgah />}
        />
        <Route
          exact
          path="/hisstori/club/my-signs"
          element={<NeshanBashgah />}
        />
        <Route
          exact
          path="/hisstori/club/my-medals"
          element={<MedalBashgah />}
        />
        <Route exact path="/printed-version" element={<PrintedVersion />} />

        {/* =================================== Without Permission =================================== */}

        <Route exact path="/book/:id/read" element={<BookRead />} />
        <Route exact path="/hisstori/safiran" element={<Ambassadors />} />
        <Route exact path="/account-safiran" element={<AccountAmbassadors />} />
        <Route exact path="/hisstori/plus" element={<HisstoriPlus />} />
        <Route exact path="/hisstori/Knowledge" element={<Knowledge />} />
        <Route exact path="/hisstori/tv-plus" element={<TvPlus />} />
        <Route
          exact
          path="/hisstori/tv-plus/examination/:id"
          element={<TvExamination />}
        />
        <Route
          exact
          path="/hisstori/knowledge/examination/:id"
          element={<KnowledgeExamination />}
        />
        <Route path="*" element={<Navigate to="/hisstori" />} />
      </Routes>
    </>
  );
};

export default Authenticated;
